module.exports = __webpack_public_path__ + "static/3-rebased-7558f374a592d82cd1d6fc582bdee478.svg";